import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Color from "../../assets/colors";
import { FontSize } from "../../assets/font";

// Grid Components //
export const ContentContainer = styled(Grid)(({ theme }) => ({
  columns: "3 auto",
  columnGap: "50px",

  [theme.breakpoints.down("sm")]: {
    columns: "1 auto",
  },
}));

export const LinkContainer = styled(Grid)({
  padding: "10px 0",
});

export const Wrapper = styled(Grid)(({ theme }) => ({
  padding: "80px 100px 100px 100px",
  margin: "0 auto",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "80px 16px 40px 16px",
  },
}));

// Link Components //
export const LinkStyled = styled(Link)({
  fontSize: FontSize.desktopCaption,
  color: Color.black,
  margin: "0 0 10px 0",
  textDecoration: "none",

  "&:hover": {
    textDecoration: "none",
    color: Color.hiredlyPurple,
  },
});

// Typography Components //
export const TitleStyled = styled(Typography)(({ theme }) => ({
  fontWeight: "700",
  fontSize: "16px",
  margin: "30px 0 15px 0",

  [theme.breakpoints.down("sm")]: {
    margin: "0 0 10px 0",
    fontSize: FontSize.desktopHeadline,
  },
}));
